/**
 * Stage 6 — Contacts / CRM frontend feature registration.
 *
 * Exposes the list / detail / dedupe / import-wizard routes and one
 * top-level nav entry. All routes are gated by the corresponding
 * `contacts:*` permissions so that read-only users see the list but
 * not the action surfaces.
 */
import React, { lazy } from 'react'
import { Route } from 'react-router-dom'
import { Contact2 } from 'lucide-react'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { lazyRoute } from '../routeHelpers'
import type { FrontendFeature } from '../types'

const ContactsListPage = lazy(() => import('./pages/ContactsListPage'))
const ContactDetailPage = lazy(() => import('./pages/ContactDetailPage'))
const ContactsDedupePage = lazy(() => import('./pages/ContactsDedupePage'))
const ContactsImportWizardPage = lazy(() => import('./pages/ContactsImportWizardPage'))

const feature: FrontendFeature = {
  navItems: [
    {
      path: '/contacts',
      label: 'Contacts',
      icon: Contact2,
      requiredPermissions: ['contacts:read'],
    },
  ],
  routes: [
    <Route
      key="contacts-list"
      path="/contacts"
      element={
        <ProtectedRoute requiredPermissions={['contacts:read']}>
          {lazyRoute(<ContactsListPage />)}
        </ProtectedRoute>
      }
    />,
    <Route
      key="contacts-import"
      path="/contacts/import"
      element={
        <ProtectedRoute requiredPermissions={['contacts:import']}>
          {lazyRoute(<ContactsImportWizardPage />)}
        </ProtectedRoute>
      }
    />,
    <Route
      key="contacts-dedupe"
      path="/contacts/dedupe"
      element={
        <ProtectedRoute requiredPermissions={['contacts:dedupe']}>
          {lazyRoute(<ContactsDedupePage />)}
        </ProtectedRoute>
      }
    />,
    <Route
      key="contacts-detail"
      path="/contacts/:id"
      element={
        <ProtectedRoute requiredPermissions={['contacts:read']}>
          {lazyRoute(<ContactDetailPage />)}
        </ProtectedRoute>
      }
    />,
  ],
}

export default feature
